<!--
	Odhlásenie a presmerovanie na úvodnú (prihlasovaciu) obrazovku
-->
<script lang="ts">
	import { DialerAgentStatus } from "../libs/app/dialer-agent-enums";
	import { api, dialerAgent } from "../bootstrap";
	import { disconnectSipClients } from "../libs/sip/connect-sip-clients";
	import { navigate } from "svelte-navigator";

	/**
	 * Odhlásenie, zrušenie sip spojení a vyčistenie konfigurácie a zoznamu spojení
	 */
	async function logout() {
		// uloženie činnosti do denníka sa urobí už priamo na serveri
		// odhláasiť sa zo servera
		await api.logout();
	}

	logout();
</script>
